import { ApiUtility } from "./ApiUtility";

class BooksService {
  route = "/posts";
  bookRoute = "/api/books?lang=";
  categoryRoute = "/api/settings/filters?lang=";
  authorRoute = "/api/authors/slug-";
  languagebyid = "/api/languages/";
  categoriesWithBook = "/api/Books/CategoriesWithBook";
  bookdetailRoute = "/api/books/";
  faviroute = "/api/books/";

  getFilters = (productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor
    );
  };

  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      this.languagebyid + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  getepubstream(bookId: string, headerWithAuth: any) {
    return ApiUtility.get(
      "api/Books/" + bookId + "/epubstream/" + bookId + ".epub",
      //this.domainname + "/api/books/" + bookId + "/epub/",
      { headers: headerWithAuth }
    );
  }
  getCategoriesWithBook(lang?: string, start?: number, length?: number, bookCount?: number, sort?: string) {
    let url = `${this.categoriesWithBook}?`;

    // Use localStorage.getItem("lan") as default if lang is not provided
    url += `lang=${lang || localStorage.getItem("lan")}`;

    if (start !== undefined) {
      url += `&start=${start}`;
    }
    if (length !== undefined) {
      url += `&length=${length}`;
    }
    if (bookCount !== undefined) {
      url += `&bookCount=${bookCount}`;
    }
    if (sort !== undefined) {
      url += `&sort=${sort}`;
    }

    return ApiUtility.get(url);
  }
  getBooks = (
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean
  ) => {
    console.log(localStorage.getItem("lan"));
    return ApiUtility.get(
      this.bookRoute +
      localStorage.getItem("lan") +
      "&start=" +
      start +
      "&length=" +
      length +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&categoryId=" +
      (categoryId ? categoryId : "") +
      "&authorId=" +
      (authorId ? authorId : "") +
      "&search=" +
      (search ? search : "") +
      "&sort=" +
      sort +
      "&bookLangauge=" +
      (langId ? langId : "") +
      "&isSpecial=" +
      isSpecial
    );
  };

  // book detail

  getBookDetail = (id: string) => {
    const lang = localStorage.getItem("lan") || "hindi";
    return ApiUtility.get(`${this.bookdetailRoute}${id}/SEO?lang=${lang}`);
  };

  getRelatedBooks = (id: string, authorId: string) => {
    return ApiUtility.get(
      this.bookdetailRoute +
      id +
      "/related?lang=" +
      localStorage.getItem("lan") +
      "&authorId=" +
      authorId
    );
  };

  addFavourite = (id: string) => ApiUtility.post(`/api/Books/${id}/favourite`, {});

  removeFavourite = (id: string) => ApiUtility.delete(`/api/Books/${id}/favourite`);

  // Fetch navigation details (TOC + lastPosition CFI)
  getNavigationDetails = (bookId: string) => {
    const payload = { bookId };
    return ApiUtility.post(`/api/Books/navigation-details`, payload);
  };

}
export default new BooksService();
